import React from 'react';
import './app.scss';
import { Route, Switch, useLocation } from 'react-router-dom';
import Recibos from './content/Recibos'
import Login from './content/Login';
import RecuperarPassword from './content/RecuperarPassword';
import NuevoPassword from './content/NuevoPassword';
import CodigoVerificacion from './content/CodigoVerificacion';
import Registro from './content/Registro';
import { Theme } from '@carbon/react';
import { useTheme } from '@carbon/react';
import HeaderCustom from './components/Header';
import { useTranslation } from 'react-i18next';
import ValidaRFC from './content/ValidaRFC';
import Perfiles from './content/Perfiles';
import AdmonUser from './content/AdmonUsuarios'


function App() {
  const { theme } = useTheme();
  const location = useLocation();
  const RUTAS_A_NO_MOSTRAR_HEADER = [
    "/",
    "/validaRfc",
    "/registro",
    "/recuperarPassword",
    "/nuevoPassword",
    "/confirmaRegistro",
    "/Codigoverificacion"
  ];
  const [t, i18n] = useTranslation("translations");
  const noMostrarHeader = () => {
    return RUTAS_A_NO_MOSTRAR_HEADER.includes(location.pathname);
  }

  return (
    <>
        {
          noMostrarHeader() ? null :
          <Theme theme={theme}>
            <HeaderCustom translation={[t, i18n]} />
          </Theme>
        }
        <Switch>
          <Route exact path="/" component={Login} />
          <Route exact path="/validaRfc" component={ValidaRFC} />
          <Route exact path="/registro" component={Registro} />
          <Route path="/recibos" component={Recibos} />
          <Route path="/recuperarPassword" component={RecuperarPassword} />
          <Route path="/nuevoPassword" component={NuevoPassword} />
          <Route path="/Codigoverificacion" component={CodigoVerificacion} />
          <Route path="/admonPerfiles" component={Perfiles} />
          <Route path="/admonUsuarios" component={AdmonUser} />
        </Switch>
    </>
  );
}

export default App;
